import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import styles from './CropWaterEventCard.css';
import { createUnit } from '../../../i18n/unitQtyWrapper';
import { LOCALE_GROUPS } from '../../../constants/units';
import { toDateString } from '../../../utils/date';

function CropWaterEventCard({
  averageCropWaterUse,
  date,
  eventIndex,
  id,
  imageUrl,
  isActive,
  onClick,
  locale,
}) {
  const time = toDateString(date, locale);
  const activeStyle = isActive ? styles.active : '';
  const averageCropWaterUseLocalized = createUnit(
    averageCropWaterUse.q,
    averageCropWaterUse.u
  )
    .forLocaleGroup(LOCALE_GROUPS.CROP_WATER_USE)
    .toString();
  return (
    <div
      className={`${activeStyle} ${styles.card}`}
      data-test-id={`cropWaterUse-card-${eventIndex}`}
      id={id}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <div className={styles.imageContainer}>
        <img
          alt={getMessage('image.cropWater.card')}
          data-test-id={`cropWaterUse-image-card-${eventIndex}`}
          src={imageUrl}
        />
      </div>
      <div className={styles.column}>
        <time
          data-test-id={`cropWaterUse-image-date-card-${eventIndex}`}
          dateTime={date}
        >
          {time}
        </time>
        <p>{getMessage('card.image.date')}</p>
        <table>
          <tbody>
            <tr className={styles.values}>
              <td data-test-id={`cropWaterUse-average-card-${eventIndex}`}>
                {averageCropWaterUseLocalized}
              </td>
            </tr>
            <tr className={styles.labels}>
              <td data-test-id={`cropWaterUse-average-label-${eventIndex}`}>
                {getMessage('card.cropwateruse.average')}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

CropWaterEventCard.propTypes = {
  averageCropWaterUse: PropTypes.object,
  date: PropTypes.string,
  eventIndex: PropTypes.number,
  id: PropTypes.string,
  imageUrl: PropTypes.string,
  isActive: PropTypes.bool,
  locale: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default CropWaterEventCard;
